import React, { Component } from "react";
import ProductHeader from "../ProductDetails/ProductHeader";
import { ReactComponent as Success } from "../CheckoutProcess/assets/success.svg";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import ActionButton from "../ActionButton";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { withRouter } from "react-router";
import { Redirect } from "react-router";
import ReviewDrawerContent from "../Branches/ReviewDrawerContent";
import { SwipeableDrawer } from "@material-ui/core";
import instance from "../../store/actions/instance";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class RegisteringSuccess extends Component {
  state = {
    open: false,
    drawerOpen: false,
  };
  toggleDrawer = (state) => {
    this.setState({ drawerOpen: state });
  };

  handleClick = async () => {
    let request = await instance.get(
      `/api/waiting/track?tracking_id=${
        this.props.tracking_id
      }&waiting_list=${1}`
    );

    request = request.data;
    if (request.success) {
      this.props.history.replace({
        pathname: "/wait/status/",
        state: { data: request.data[0], tracking_id: this.props.tracking_id },
      });
    }
  };
  render() {
    const language = this.props.language;

    const copyToClipboard = () => {
      const textField = document.createElement("textarea");
      textField.innerText = this.props.tracking_id;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
    };
    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }

      this.setState({ open: false });
    };
    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader onBack={() => this.props.history.replace("/")} />
        {this.props.settings.enable_feedback && (
          <SwipeableDrawer
            anchor="bottom"
            open={this.state.drawerOpen}
            onClose={() => this.toggleDrawer(false)}
            PaperProps={{
              style: { minHeight: 100, height: "auto" },
              className: "text-center",
            }}
            onBackdropClick={() => this.toggleDrawer(false)}
          >
            <ReviewDrawerContent
              closeDrawer={() => this.toggleDrawer(false)}
              trackingCode={this.props.tracking_id}
            />
          </SwipeableDrawer>
        )}
        <Snackbar
          open={this.state.open}
          autoHideDuration={3000}
          onClose={handleClose}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert onClose={handleClose} severity="success">
            {language == "english"
              ? "Code copied successfully!"
              : "تم نسخ رقم التتبع"}
          </Alert>
        </Snackbar>
        <div className="free-space-190-white"></div>

        <Success width="100" height="100" />
        <p
          className="mt-4"
          style={{ fontSize: "1rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language == "english"
            ? "Your registered in the waiting list successfully!"
            : "لقد تم التسجيل بنجاح!"}
        </p>
        <p
          className="mt-4"
          style={{ fontSize: "1rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language == "english" ? "Your tracking code is:" : "رقم تتبعك  هو:"}{" "}
          <span style={{ fontWeight: 600 }}>{this.props.tracking_id}</span>
        </p>
        <Button
          variant="contained"
          className="mt-4"
          color="primary"
          disableElevation
          onClick={() => {
            copyToClipboard();
            this.setState({ open: true });
          }}
          endIcon={language == "english" ? <AssignmentIcon /> : null}
          startIcon={language == "arabic" ? <AssignmentIcon /> : null}
        >
          {language == "english" ? "Copy Code" : "نسخ رقم التتبع"}
        </Button>

        <div style={{ display: "block", marginTop: 10 }}>
          <Button
            variant="contained"
            className="mt-4 mx-auto"
            color="primary"
            disableElevation
            onClick={() => {
              this.handleClick();
              this.props.history.push("/waa/", {
                trackingCode: this.props.tracking_id,
              });
            }}
            endIcon={language == "english" ? <MyLocationIcon /> : null}
            startIcon={language == "arabic" ? <MyLocationIcon /> : null}
          >
            {language == "english" ? "Track Order" : "تتبع الطلب"}
          </Button>
        </div>
        {this.props.settings.enable_feedback && (
          <Button
            color="primary"
            className="mt-5"
            onClick={() => this.toggleDrawer(true)}
            endIcon={language == "english" && <ThumbUpIcon />}
            startIcon={language == "arabic" && <ThumbUpIcon />}
          >
            {language == "english" ? "Rate your experience" : "قيم تجربتك"}
          </Button>
        )}
        <div className="free-space-80-white"></div>
        <ActionButton
          action={
            language == "english"
              ? "Back to shopping"
              : "العودة الى القائمة الرئيسية"
          }
          onClick={() => this.props.history.replace("/")}
          allowWithMenu
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(withRouter(RegisteringSuccess));
